import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
const bonuses = [{
  n: '01',
  title: 'Checklist Maestra de Supervivencia (Imprimible)',
  desc: 'Tu centro de control total. Paso a paso desde 4 semanas antes hasta la última velita. Marcá cada tarea y tené todo bajo control.',
  price: '$14.990'
}, {
  n: '02',
  title: 'Pack de 10 Plantillas de Invitaciones Digitales',
  desc: '10 diseños profesionales de las temáticas más pedidas. Completás los datos y los enviás por WhatsApp en segundos.',
  price: '$9.990'
}, {
  n: '03',
  title: 'El Guion del "Animador Improvisado"',
  desc: 'Minuto a minuto con qué decir y qué hacer para liderar la fiesta vos misma. Incluye torta, piñata y retiro de invitados.',
  price: '$7.990'
}, {
  n: '04',
  title: 'Mapa de Proveedores Estratégicos',
  desc: 'Comprá donde compran las que saben: cotillón mayorista, gráficas económicas y distribuidores para ganarle a la inflación.',
  price: '$7.990'
}, {
  n: '05',
  title: 'Fichas de "Recreo Épico" — 30 Juegos por Edad',
  desc: '30 fichas con juegos explicados según la edad de los invitados. Sin materiales caros: elegís la ficha y listo.',
  price: '$5.990'
}];
export function Bonuses() {
  return <section aria-label="Bonos" className="border-y border-white/5 bg-ink-2" data-id="element-14" data-mp="3n4wkkmuj3qmo">
      <div className="mx-auto max-w-5xl px-5 pt-[0px] pb-[22px]" data-id="element-15" data-mp="2zfanc4xpvlhb">
        <h2 className="pt-[8px] text-center font-display text-3xl font-black text-white sm:text-4xl" data-id="element-16" data-mp="2zhogg88u6nm8">
          🎁 5 Bonos estratégicos
        </h2>

        <div className="mt-12 grid gap-5 sm:grid-cols-2" data-id="element-17" data-mp="38gikuksesiac">
          {bonuses.map((b, i) => <motion.div key={b.n} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.4,
          delay: i % 2 * 0.08
        }} className="relative flex flex-col rounded-2xl border border-azure/20 bg-ink p-6 pt-[5px] pb-[0px]" data-id="element-18" data-mp="33gns0bp2pimn" data-mpi={i}>
              <div className="mb-3 flex items-center justify-between" data-id="element-19" data-mp="3hhhqmmwfzz6j">
                <span className="inline-flex items-center gap-1.5 rounded-full bg-azure/15 px-3 py-1 text-xs font-bold text-azure" data-id="element-20" data-mp="3hju5gr6wltfd">
                  <GiftIcon className="h-3.5 w-3.5" data-id="element-21" data-mp="3qixro41daoy3" /> Bono {b.n}
                </span>
                <span className="text-sm font-bold" data-id="element-22" data-mp="2tsyl2f4s20i5">
                  <span className="text-white/40 line-through" data-id="element-23" data-mp="2tu9naaikr075">{b.price}</span>{' '}
                  <span className="text-iris-soft" data-id="element-24" data-mp="2xujshkyjlmky">GRATIS</span>
                </span>
              </div>
              <h3 className="text-base font-bold text-white" data-id="element-25" data-mp="32rk225ulp7gt">{b.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-white/60" data-id="element-26" data-mp="37kv844rl9k7o">{b.desc}</p>
            </motion.div>)}
        </div>

        <div className="mt-10 rounded-2xl border border-iris/40 bg-iris/10 p-6 text-center" data-id="element-27" data-mp="2a4617wns7rrf">
          <p className="text-base font-bold text-white sm:text-lg" data-id="element-28" data-mp="2f1potn6ddgw1">
            Valor total de los bonos:{' '}
            <span className="text-white/50 line-through" data-id="element-29" data-mp="27hx4wyajlw2z">$46.950</span>{' '}
            <span className="text-iris-soft" data-id="element-30" data-mp="22lg8lgt6wbet">HOY GRATIS CON TU MEGAPACK</span>
          </p>
        </div>
      </div>
    </section>;
}